import { Routes } from '@angular/router';

export const RUTAS: Routes = [
    {
        path: 'products',
        loadChildren: () => import('../modules/products/products.module').then(m => m.ProductsModule)
    },
    {
        path: 'novedades',
        loadChildren: () => import('../modules/novedades/novedades.module').then(m => m.NovedadesModule)
    },
    {
        path: 'almuerzos',
        loadChildren: () => import('../modules/almuerzos/almuerzos.module').then(m => m.AlmuerzosModule)
    },
    {
        path: 'backOffice',
        loadChildren: () => import ('../modules/backoffice/backoffice.module').then(m => m.BackofficeModule)
    },
    {
        path: 'user',
        loadChildren: () => import ('../modules/user/user.module').then(m => m.UserModule)
    },
    {
        path: 'reportes',
        loadChildren: () => import ('../modules/reportes/reportes.module').then(m => m.ReportesModule)
    },
    {
        path: 'puestos',
        loadChildren: () => import ('../modules/puestos/puestos.module').then(m => m.PuestosModule)
    },
    {
        path: 'evaluaciones',
        loadChildren: () => import ('../modules/evaluaciones/evaluaciones.module').then(m => m.EvaluacionesModule)
    }
];